import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CycleEditComponent} from '@ma-dashboard/cycle-edit/cycle-edit.component';
import {filter, switchMap} from 'rxjs/operators';
import {Cycle} from '@services/model/cycle';
import {CycleService} from '@services/cycle.service';
import {ConfirmDialogComponent} from '@widgets/confirm-dialog/confirm-dialog.component';
import {MatCard, MatCardActions, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MinPrivilegeDirective} from '@util/directives/min-privilege.directive';
import {CommonModule} from '@angular/common';
import {MomentPipe} from '@util/pipes/moment-pipe';
import {MatAnchor} from '@angular/material/button';

@Component({
  selector: 'app-cycles',
  templateUrl: './cycles.component.html',
  styleUrls: ['./cycles.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCard, MatCardTitle, MatCardContent, MatCardActions, MatIcon, MarkantElementsModule, MinPrivilegeDirective, MomentPipe, MatAnchor],
})
export class CyclesComponent implements OnInit {
  cycles: Cycle[];
  constructor(
    private readonly cycleService: CycleService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadCycles();
  }

  loadCycles() {
    this.cycleService.getAll(false).subscribe((cs) => {
      this.cycles = cs;
    });
  }

  delete(c: Cycle): void {
    /* confirmation dialog */
    const d = this.dialog.open(ConfirmDialogComponent, {data: {title: `Löschen bestätigen`, message: `Möchten Sie die Runde '${c.name}' wirklich löschen?`}});

    d.afterClosed()
      .pipe(
        filter((r) => r === 'confirm'),
        switchMap(() => this.cycleService.delete(c.uuid as string)),
      )
      .subscribe(() => this.loadCycles());
  }

  edit(c: Cycle): void {
    const d = this.dialog.open(CycleEditComponent, {width: '800px', data: c});

    d.afterClosed()
      .pipe(
        filter((r) => r !== null),
        switchMap((r) => this.cycleService.update(r)),
      )
      .subscribe(() => this.loadCycles());
  }
  add(): void {
    const d = this.dialog.open(CycleEditComponent, {width: '800px', data: null});

    d.afterClosed()
      .pipe(
        filter((r) => r !== null),
        switchMap((r) => this.cycleService.create(r)),
      )
      .subscribe(() => this.loadCycles());
  }
}
